import { NgModule } from '@angular/core';
import { MailToButtonComponent } from './mail-to-button.component';

@NgModule({
  imports: [MailToButtonComponent],
  exports: [MailToButtonComponent],
})
export class MailToButtonModule {}
